import React, { useState, useEffect } from 'react';
import {
  Box, Button, Typography, Stack, TextField, Select, MenuItem, Chip,
  Table, TableHead, TableBody, TableRow, TableCell, IconButton, Dialog, Drawer,
  FormControl, InputLabel, Switch,
  CssBaseline,
  Paper,
  TableContainer
} from '@mui/material';
import { Add, Edit, Delete, Visibility, RemoveRedEyeOutlined, AttachMoney, TrendingUp, Assessment, Inventory } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import AppNavbar from '../../../components/AppNavbar';
import Header from '../../../components/Header';
import SideMenu from '../../../components/SideMenu';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../../dashboard/theme/customizations';
import AppTheme from '../../../shared-theme/AppTheme';
import { StyledCellHeader } from '../../../components/StyledCellHeader';
import CrearListadePreciosDialog from './crearlistadialog';
import { grey } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import { fetchListasDePrecios } from '../../../utils/generalsFetch';
import AccessDeniedBox from '../../../components/AccessDeniedBox';
import EmptyState from '../../../components/EmptyState';

const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
  };

const tiposLista = [
  { value: 'general', label: 'General' },
  { value: 'sucursal', label: 'Por Sucursal' },
  { value: 'cliente', label: 'Por Tipo de Cliente' },
];

const datosIniciales = [
  {
    id: 1,
    nombre: 'Lista General A',
    tipo: 'general',
    fecha: '2025-07-01',
    productos: 5,
    activa: true,
  },
];

export default function ListasDePrecios(props) {
  const navigate = useNavigate()
  const [filtros, setFiltros] = useState({ nombre: '', tipo: '', activa: '' });
  const [listaForm, setListaForm] = useState({ nombre: '', tipo: '', target: '', productos: [], activa: true });
  const [openEditList, setOpenEditList] = useState(false)
  const [listas, setListas] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [nuevaLista, setNuevaLista] = useState({
    nombre: '',
    tipo: '',
    sucursalOCliente: '',
    productos: [],
    activa: true,
  });
  const [accessDenied, setAccessDenied] = React.useState(false);


  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNuevaLista({ nombre: '', tipo: '', sucursalOCliente: '', productos: [], activa: true });
  };

  const handleGuardarLista = () => {
    setListas([...listas, { ...nuevaLista, fecha: new Date().toLocaleDateString() }]);
    handleCloseDialog();
  };
  const handleChangeFiltro = (e) => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const handleChangeForm = (e) => {
    setListaForm({ ...listaForm, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    fetchListasDePrecios({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then(data => {
      setListas(data);
    }).catch((error) => {
      setAccessDenied(true);
    });
  }, []);

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
            <SideMenu />
            <AppNavbar />
            {/* Main content */}
            <Box
            component="main"
            sx={(theme) => ({
                flexGrow: 1,
                backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
                overflow: 'auto',
            })}
            >
            <Stack
                spacing={2}
                sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
                }}
            >
                <Header parent={"Logistica y Almacenes"} child={"Categorias"}/>

                {!accessDenied ? 
                <Box sx={{ p: 4 }}>
                    <Box display="flex"  px={2} justifyContent={"space-between"}>
                        <Typography variant="h4" fontWeight="bold">Listas de Precios</Typography>
                        <Button variant="contained" startIcon={<Add/>} color='primarybutton' sx={{marginLeft:10,height: 32 , fontWeight:"bold"}} onClick={() => setOpenDialog(true)}>Crear Lista de Precios</Button>
                    </Box>

                    {/* Show empty state if no price lists */}
                    {listas.length === 0 ? (
                        <EmptyState 
                            icon={AttachMoney}
                            title="No hay listas de precios"
                            description="Comienza creando tu primera lista de precios para gestionar los precios de productos de manera organizada y eficiente."
                            features={[
                                {
                                    icon: Inventory,
                                    title: "Gestión de Precios",
                                    description: "Control completo de precios por producto"
                                },
                                {
                                    icon: TrendingUp,
                                    title: "Listas Personalizadas",
                                    description: "Precios específicos por sucursal o cliente"
                                },
                                {
                                    icon: Assessment,
                                    title: "Reportes de Precios",
                                    description: "Análisis de precios y rentabilidad"
                                }
                            ]}
                            buttonText="Crear Primera Lista de Precios"
                            onButtonClick={() => setOpenDialog(true)}
                            helpText="¿Necesitas ayuda? Contacta a soporte técnico para guiarte en el proceso"
                        />
                    ) : (
                        <>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2, mt:5}}>
                            <TextField placeholder="Buscar por nombre" name="nombre" value={filtros.nombre} onChange={handleChangeFiltro} fullWidth/>
                        </Box>

                        <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 'none', mt: 2 }}>
                        <Table >
                            <TableHead>
                            <TableRow>
                                <StyledCellHeader>Nombre</StyledCellHeader>
                                <StyledCellHeader>Descripción</StyledCellHeader>
                                <StyledCellHeader>Productos</StyledCellHeader>
                                <StyledCellHeader>Fecha de creación</StyledCellHeader>
                                <StyledCellHeader></StyledCellHeader>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {listas.map((lista) => (
                                <TableRow key={lista.value}>
                                <TableCell>{lista.label}</TableCell>
                                <TableCell>{lista.description}</TableCell>
                                <TableCell>{lista.cantidad_productos}</TableCell>
                                <TableCell>{lista.fecha}</TableCell>
                                <TableCell>
                                    <IconButton  size="small" sx={{ color: "#617689" }} onClick={()=>{ navigate(`/logistica/Listasdeprecios/${lista.value}`)}}><RemoveRedEyeOutlined sx={{color:grey[400]}}/></IconButton>
                                </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        </>
                    )}

                    <CrearListadePreciosDialog
                        open={openDialog}
                        onClose={handleCloseDialog}
                    />

                </Box>
                :
                <Box>
                  <br></br>
                  <br></br>
                  <AccessDeniedBox
                    title={'Acceso denegado'}
                    message={'No tienes permisos para ver esta sección de Listas de Precios. Contacta a tu administrador para solicitar acceso o verifica tus roles y permisos.'}
                  />
                </Box>
                }



            </Stack>
            </Box>
        </Box>
    </AppTheme>

  );
}
